/**
 * The server's own sentence for a refused request (4xx with a text body, e.g. "This client is
 * archived. Reactivate it first." or "Not found. It may have been deleted, or it belongs to another
 * firm."), otherwise the fallback (QA batch 13/14).
 *
 * The server answers most refusals as plain text, which RTK Query reports as status
 * "PARSING_ERROR" with the real status in `originalStatus` (QA batch 14: before, those sentences
 * were never shown). 5xx answers always use the fallback.
 */
export const serverMessage = (error: unknown, fallback: string): string => {
  const failure = error as
    | { status?: unknown; originalStatus?: unknown; data?: unknown }
    | null
    | undefined;
  const status =
    typeof failure?.status === "number"
      ? failure.status
      : failure?.status === "PARSING_ERROR" &&
        typeof failure?.originalStatus === "number"
      ? failure.originalStatus
      : 0;
  if (status < 400 || status >= 500) return fallback;
  const data = failure?.data;
  const text =
    typeof data === "string"
      ? data
      : typeof (data as { message?: unknown })?.message === "string"
      ? (data as { message: string }).message
      : "";
  const clean = text.trim();
  // A real sentence only (not an HTML page, a JSON dump or a stack trace).
  if (
    !clean ||
    clean.length > 300 ||
    /^[<{[]/.test(clean) ||
    clean.includes("Exception")
  ) {
    return fallback;
  }
  return clean;
};
